import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("woop_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const auth = {
  register: (data) => api.post("/auth/register", data).then((r) => r.data),
  login: (data) => api.post("/auth/login", data).then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
};

export const courses = {
  list: () => api.get("/courses").then((r) => r.data),
  get: (id) => api.get(`/courses/${id}`).then((r) => r.data),
  mine: () => api.get("/my-courses").then((r) => r.data),
};

export const leads = {
  create: (data) => api.post("/leads", data).then((r) => r.data),
};

export const chat = {
  send: (session_id, message, lang) =>
    api.post("/chat", { session_id, message, lang }).then((r) => r.data),
};

export const checkout = {
  create: (course_id, origin_url) =>
    api.post("/checkout/create-session", { course_id, origin_url }).then((r) => r.data),
  status: (session_id) => api.get(`/checkout/status/${session_id}`).then((r) => r.data),
};

export const paypal = {
  createOrder: (course_id, origin_url) =>
    api.post("/paypal/create-order", { course_id, origin_url }).then((r) => r.data),
  captureOrder: (order_id) =>
    api.post("/paypal/capture-order", { order_id }).then((r) => r.data),
  status: (order_id) => api.get(`/paypal/status/${order_id}`).then((r) => r.data),
};

export const subscription = {
  create: (origin_url) =>
    api.post("/paypal/create-subscription", { origin_url }).then((r) => r.data),
  confirm: (subscription_id) =>
    api.post("/paypal/confirm-subscription", { subscription_id }).then((r) => r.data),
  me: () => api.get("/subscription/me").then((r) => r.data),
  cancel: () => api.post("/subscription/cancel").then((r) => r.data),
};

export const track = {
  visit: (data = {}) => api.post("/track/visit", data).then((r) => r.data),
};

export const subscribers = {
  create: (data) => api.post("/subscribe", data).then((r) => r.data),
};

export const referrals = {
  me: () => api.get("/referrals/me").then((r) => r.data),
};

export const admin = {
  metrics: () => api.get("/admin/metrics").then((r) => r.data),
  leads: () => api.get("/admin/leads").then((r) => r.data),
  users: () => api.get("/admin/users").then((r) => r.data),
  transactions: () => api.get("/admin/transactions").then((r) => r.data),
  paypalStats: () => api.get("/admin/paypal-stats").then((r) => r.data),
  subscribers: () => api.get("/admin/subscribers").then((r) => r.data),
  traffic: () => api.get("/admin/traffic").then((r) => r.data),
  referrals: () => api.get("/admin/referrals").then((r) => r.data),
};

export const blog = {
  list: () => api.get("/blog").then((r) => r.data),
  get: (slug) => api.get(`/blog/${slug}`).then((r) => r.data),
  leadMagnet: (slug, data) => api.post(`/blog/${slug}/lead-magnet`, data).then((r) => r.data),
};

export const adminBlog = {
  list: () => api.get("/admin/blog").then((r) => r.data),
  create: (data) => api.post("/admin/blog", data).then((r) => r.data),
  update: (id, data) => api.put(`/admin/blog/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/admin/blog/${id}`).then((r) => r.data),
  generate: (data) =>
    api.post("/admin/ai/generate-infoproduct", data, { timeout: 180000 }).then((r) => r.data),
};
